  const SponsorsData = [
  {
    id:  1,
    logoPath: "https://ik.imagekit.io/wwg4nuz3a/sponsors/sacmm-law.png?tr=w-500,h-100",
  },
  {
    id:  2,
    logoPath: "https://ik.imagekit.io/wwg4nuz3a/sponsors/rebleza-dental-clinic.png?tr=w-500,h-500",
  },
  {
    id:  3,
    logoPath: "https://ik.imagekit.io/wwg4nuz3a/sponsors/guzman-logo.png?tr=w-500,h-100",
  },
  {
    id:  4,
    logoPath: "https://ik.imagekit.io/wwg4nuz3a/sponsors/jems.png?tr=w-500,h-100",
  },
  {
    id:  5,
    logoPath: "https://ik.imagekit.io/wwg4nuz3a/sponsors/standard-insurance.jpg?tr=w-500,h-100",
  },
  {
    id:  6,
    logoPath: "https://ik.imagekit.io/wwg4nuz3a/sponsors/cci-furniture.jpg?tr=w-500,h-100",
  },
  {
    id:  7,
    logoPath: "https://ik.imagekit.io/wwg4nuz3a/sponsors/jmar.jpg?tr=w-500,h-100",
  },
  {
    id:  8,
    logoPath: "https://ik.imagekit.io/wwg4nuz3a/sponsors/z-j-creations.jpg?tr=w-500,h-100",
  },
  {
    id:  9,
    logoPath: "https://ik.imagekit.io/wwg4nuz3a/sponsors/rooftop-lights-and-sound-system.jpg?tr=w-500,h-250",
  },
  {
    id:  10,
    logoPath: "https://ik.imagekit.io/wwg4nuz3a/sponsors/mzet.jpg?tr=w-500,h-100",
  },
  {
    id:  11,
    logoPath: "https://ik.imagekit.io/wwg4nuz3a/sponsors/dash-coffee.jpg?tr=w-500,h-100",
  },
  {
    id:  12,
    logoPath: "https://ik.imagekit.io/wwg4nuz3a/sponsors/tcmc.jpg?tr=w-500,h-100",
  },
  {
    id:  13,
    logoPath: "https://ik.imagekit.io/wwg4nuz3a/sponsors/pico.jpg?tr=w-500,h-100",
  },
  {
    id:  14,
    logoPath: "https://ik.imagekit.io/wwg4nuz3a/sponsors/czar-law.jpg?tr=w-500,h-100",
  },
  {
    id:  15,
    logoPath: "https://ik.imagekit.io/wwg4nuz3a/sponsors/narzabal-law.png?tr=w-500,h-100",
  },
  {
    id:  16,
    logoPath: "https://ik.imagekit.io/wwg4nuz3a/sponsors/tanix.jpg?tr=w-500,h-100",
  },
  {
    id:  17,
    logoPath: "https://ik.imagekit.io/wwg4nuz3a/sponsors/surround.jpg?tr=w-500,h-100",
  },
  {
    id:  18,
    logoPath: "https://ik.imagekit.io/wwg4nuz3a/sponsors/cbt-law.jpg?tr=w-500,h-100",
  },
  {
    id:  19,
    logoPath: "https://ik.imagekit.io/wwg4nuz3a/sponsors/vee-ar.jpg?tr=w-500,h-100",
  },
  {
    id:  20,
    logoPath: "https://ik.imagekit.io/wwg4nuz3a/sponsors/master-ad-agency.png?tr=w-500,h-100",
  },
]

export default SponsorsData;